export default __webpack_public_path__ + "static/media/style20.25bdd2ed.svg";